export default "__VITE_ASSET__DsPVLLra__"